<template>
  <li class="menu-item">
    <a href="#" @click.stop="click"><t-icon name="icon-add-fav" /></a>
    <ul class="sub-menu-items" ref="submenu" :style="submenuStyle">
      <li class="sub-menu-item">
        <a href="#" v-if="!evenIsFav" @click.prevent="addFav(evenPage.pageNumber)"><t-icon name="icon-page-left" /></a>
        <a href="#" v-else @click.prevent="removeFav(evenPage.pageNumber)"><t-icon name="icon-page-left-selected" /></a>
      </li>
      <li class="sub-menu-item">
        <a v-if="!evenIsFav && !oddIsFav" @click.prevent="addFav(evenPage.pageNumber);addFav(oddPage.pageNumber)" href="#"><t-icon name="icon-spread" /></a>
        <a v-else-if="evenIsFav && oddIsFav" @click.prevent="removeFav(evenPage.pageNumber);removeFav(oddPage.pageNumber)" href="#"><t-icon name="icon-spread-selcted-both" /></a>
        <a v-else-if="evenIsFav && !oddIsFav" @click.prevent="addFav(oddPage.pageNumber)" href="#"><t-icon name="icon-spread-selcted-left" /></a>
        <a v-else-if="!evenIsFav && oddIsFav" @click.prevent="addFav(evenPage.pageNumber)" href="#"><t-icon name="icon-spread-selcted-right" /></a>
      </li>
      <li class="sub-menu-item">
        <a href="#" v-if="!oddIsFav" @click.prevent="addFav(oddPage.pageNumber)"><t-icon name="icon-page-right" /></a>
        <a href="#" v-else @click.prevent="removeFav(oddPage.pageNumber)"><t-icon name="icon-page-right-selected" /></a>
      </li>
      <li class="sub-menu-item">
        <a href="#" @click="click"><t-icon name="icon-add-fav" /></a>
      </li>
    </ul>
  </li>
</template>

<script>
import uiUtil from '@/utils/ui'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      open: false,
      submenuEl: null,
      rootEl: null,
      submenuWidth: null
    }
  },
  mounted () {
    this.rootEl = this.$el
  },
  created () {
    document.addEventListener('click', this.clickoutside)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.clickoutside)
  },
  methods: {
    ...mapActions({ addFav: 'addFavorite', removeFav: 'removeFavorite' }),
    click (event) {
      event.preventDefault()
      this.open = !this.open
    },
    clickoutside (event) {
      uiUtil.clickOutside(event, this.$refs.submenu, clickOutside => {
        if (this.open && clickOutside) {
          this.open = false
        }
      })
    }
  },
  computed: {
    evenIsFav () {
      if (this.evenPage != null) {
        return this.$store.getters.favoriteByPageNumber(this.$store.getters.evenPage.pageNumber) != null
      }
      return false
    },
    oddIsFav () {
      if (this.oddPage != null) {
        return this.$store.getters.favoriteByPageNumber(this.$store.getters.oddPage.pageNumber) != null
      }
      return false
    },
    submenuStyle () {
      let numberOfMenuitems
      if (this.$store.getters.spread) {
        numberOfMenuitems = 4
      } else {
        numberOfMenuitems = 2
      }

      return {
        'min-width': `${(numberOfMenuitems * 55)}px`
      }
    },
    ...mapGetters(['oddPage', 'evenPage'])
  },
  watch: {
    open (newVal) {
      this.$el.classList.toggle('open')
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
</style>
